import ArtistIcon from "../../../assets/icons/ArtistIcon";
import ContactIcon from "../../../assets/icons/ContactIcon";
import EmailIcon from "../../../assets/icons/EmailIcon";
import ExhibitionIcon from "../../../assets/icons/ExhibitionIcon";
import FileTextIcon from "../../../assets/icons/FileTextIcon";
import ImageIcon from "../../../assets/icons/ImageIcon";
import LayersIcon from "../../../assets/icons/LayersIcon";
import ListIcon from "../../../assets/icons/ListIcon";
import LocationPinIcon from "../../../assets/icons/LocationPinIcon";
import LogoutIcon from "../../../assets/icons/LogoutIcon";
import OfferIcon from "../../../assets/icons/OfferIcon";
import PdfIcon from "../../../assets/icons/PdfIcon";
import ReportIcon from "../../../assets/icons/ReportIcon";
import ReservationIcon from "../../../assets/icons/ReservationIcon";
import ServerIcon from "../../../assets/icons/ServerIcon";
import SettingsIcon from "../../../assets/icons/SettingsIcon";
import ShipmentIcon from "../../../assets/icons/ShipmentIcon";
import WarehouseIcon from "../../../assets/icons/WarehouseIcon";

const modules = [
  {
    icon: EmailIcon,
    label: "Email Module",
    name: "email",
    pathname: "/email",
    permission: "EMAIL_MODULE",
  },
  {
    icon: ContactIcon,
    label: "Contacts",
    name: "contact",
    pathname: "/contacts",
    permission: "CONTACT_MODULE",
  },
  {
    icon: SettingsIcon,
    label: "Admin",
    name: "admin",
    pathname: "/admin/users",
    permission: "ADMIN_MODULE",
  },
  {
    icon: ImageIcon,
    label: "Artworks",
    name: "artworks",
    pathname: "/artworks",
    permission: "ARTWORK_MODULE",
  },
  {
    icon: LayersIcon,
    label: "Instance",
    name: "instance",
    pathname: "/instance",
    permission: "INSTANCE_MODULE",
  },
  {
    icon: FileTextIcon,
    label: "Invoice",
    name: "invoice",
    pathname: "/invoice",
    permission: "INVOICE_MODULE",
  },
  {
    icon: LogoutIcon,
    label: "Consignment",
    name: "consignment",
    pathname: "/consignment",
    permission: "CONSIGNMENT_MODULE",
  },
  {
    icon: ListIcon,
    label: "Select Lists",
    name: "select-lists",
    pathname: "/select-lists",
    permission: "SELECT_LIST_MODULE",
  },
  {
    icon: ShipmentIcon,
    label: "Shipment",
    name: "shipment",
    pathname: "/shipments",
    permission: "SHIPMENT_MODULE",
  },
  {
    icon: WarehouseIcon,
    label: "Warehouse",
    name: "warehouse",
    pathname: "/warehouse",
    permission: "WAREHOUSE_MODULE",
  },
  {
    icon: LocationPinIcon,
    label: "Sites",
    name: "sites",
    pathname: "/sites/locations",
    permission: "MANAGE_WAREHOUSE_SITES",
  },
  {
    icon: ServerIcon,
    label: "Jobs",
    name: "jobs",
    pathname: "/jobs",
    permission: "JOB_MODULE",
  },
  {
    icon: OfferIcon,
    label: "Offer",
    name: "offer",
    pathname: "/offer",
    permission: "OFFER_MODULE",
  },
  {
    icon: FileTextIcon,
    label: "Reports",
    name: "reports",
    pathname: "/reports",
    permission: "REPORT_MODULE",
  },
  {
    icon: PdfIcon,
    label: "PDF Generator",
    name: "pdf-generator",
    pathname: "/pdf-generator",
  },
  {
    icon: ReportIcon,
    label: "Reporting",
    name: "reporting",
    pathname: "/reporting",
  },
  {
    icon: ArtistIcon,
    label: "Artists",
    name: "artist",
    pathname: "/artist",
    permission: "ARTIST_MODULE",
  },
  {
    icon: ExhibitionIcon,
    label: "Exhibitions",
    name: "exhibition",
    pathname: "/exhibition",
    permission: "EXHIBITION_MODULE",
  },
  {
    icon: ReservationIcon,
    label: "Reservations",
    name: "reservation",
    pathname: "/reservations",
    permission: "RESERVATION_MODULE",
  },
];

const getPermittedModules = hasPermission =>
  modules.filter(
    module => !module.permission || hasPermission(module.permission),
  );

const getFirstPathSegment = pathname => pathname?.split("/").filter(Boolean)[0];

const getCurrentModule = pathname => {
  const segment = getFirstPathSegment(pathname);
  return segment
    ? modules.find(module => getFirstPathSegment(module.pathname) === segment)
    : undefined;
};

export { getCurrentModule, getPermittedModules, modules };
